<template>
    <div class="pa-5 compact-form" v-if="activeRule">
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Description" | t }}</v-col>
            <v-col cols="6">
                <v-text-field
                    :value="activeRule.description"
                    @input="updateField($event, 'description')"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Info provider" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    :value="activeRule.info_provider"
                    @input="updateField($event, 'info_provider')"
                    placeholder="Select"
                    :items="infoProviders"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>

        <v-row no-gutters v-if="activeRule.info_provider === 'odoo'">
            <v-col cols="12">
                <v-row no-gutters
                    ><v-col cols="3" class="mt-2 row-title">{{ "Export client" | t }}</v-col>
                    <v-col cols="6">
                        <v-autocomplete
                            :value="activeRule.export_client_id"
                            :items="export_clients"
                            :loading="loadingRuleData"
                            class="text-field-item mb-1"
                            clearable
                            dense
                            hide-details
                            hide-no-data
                            hide-selected
                            item-text="name"
                            item-value="id"
                            outlined
                            @change="updateField($event, 'export_client_id')"
                        /> </v-col
                ></v-row>
            </v-col>
            <v-col cols="12">
                <v-row no-gutters
                    ><v-col cols="3" class="mt-2 row-title">{{ "Client" | t }}</v-col>
                    <v-col cols="6">
                        <v-autocomplete
                            :value="activeRule.client_id"
                            :items="clients"
                            :loading="loadingRuleData"
                            class="text-field-item mb-1"
                            clearable
                            dense
                            hide-details
                            hide-no-data
                            hide-selected
                            item-text="name"
                            item-value="id"
                            outlined
                            @change="updateField($event, 'client_id')"
                        /> </v-col
                ></v-row>
            </v-col>
        </v-row>
        <v-row no-gutters v-else>
            <v-col cols="12"
                ><v-row no-gutters
                    ><v-col cols="3" class="mt-2 row-title">{{ "Store" | t }}</v-col>
                    <v-col cols="6">
                        <v-autocomplete
                            :value="activeRule.store_id"
                            :items="stores"
                            :loading="loadingRuleData"
                            class="text-field-item mb-1"
                            clearable
                            dense
                            hide-details
                            hide-no-data
                            hide-selected
                            item-text="name"
                            item-value="id"
                            outlined
                            @change="updateField($event, 'store_id')"
                        /> </v-col></v-row
            ></v-col>
            <v-col cols="12"
                ><v-row no-gutters
                    ><v-col cols="3" class="mt-2 row-title">{{ "Tag" | t }}</v-col>
                    <v-col cols="6">
                        <v-autocomplete
                            :value="activeRule.tag_id"
                            :items="tags"
                            :loading="loadingRuleData"
                            class="text-field-item mb-1"
                            clearable
                            dense
                            hide-details
                            hide-no-data
                            hide-selected
                            item-text="name"
                            item-value="id"
                            outlined
                            @change="updateField($event, 'tag_id')"
                        /> </v-col></v-row
            ></v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="3" class="mt-2 row-title">{{ "Start date" | t }}</v-col>
            <v-col cols="6">
                <date-picker v-model="startDate" :popover="{ placement: 'bottom', visibility: 'click' }">
                    <v-text-field
                        :value="getDate(startDate)"
                        append-icon="fas fa-calendar"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                    />
                </date-picker>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col cols="3" class="mt-2 row-title">{{ "End date" | t }}</v-col>
            <v-col cols="6">
                <date-picker v-model="endDate" :popover="{ placement: 'bottom', visibility: 'click' }">
                    <v-text-field
                        :value="getDate(endDate)"
                        append-icon="fas fa-calendar"
                        class="text-field-item mb-1"
                        dense
                        hide-details
                        outlined
                    />
                </date-picker>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Amount" | t }}</v-col>
            <v-col cols="6">
                <v-row no-gutters>
                    <template
                        ><v-col v-if="isFlat" cols="8" class="pr-2">
                            <v-text-field
                                :value="activeRule.amount"
                                @input="updateField($event, 'amount')"
                                append-icon="fas fa-euro-sign"
                                class="text-field-item mb-1"
                                type="number"
                                step="1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                        <v-col v-else cols="8" class="pr-2">
                            <v-text-field
                                :value="activeRule.percent"
                                @input="updateField($event, 'percent')"
                                append-icon="fas fa-percent"
                                class="text-field-item mb-1"
                                type="number"
                                step="1"
                                hide-details
                                dense
                                outlined
                            />
                        </v-col>
                        <v-col cols="4" class="d-flex" style="align-items: stretch">
                            <v-btn-toggle v-model="isFlat" dense mandatory>
                                <v-btn :value="true" style="height: 90%">{{ "Flat" | t }}</v-btn>
                                <v-btn :value="false" style="height: 90%">{{ "Percent" | t }}</v-btn>
                            </v-btn-toggle>
                        </v-col>
                    </template>


                </v-row>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-col class="mt-2 row-title" cols="3">{{ "Entry type" | t }}</v-col>
            <v-col cols="6">
                <v-select
                    :value="activeRule.entry_type"
                    @input="updateField($event, 'entry_type')"
                    placeholder="Select"
                    :items="entryTypes"
                    class="text-field-item mb-1"
                    hide-details
                    dense
                    outlined
                />
            </v-col>
        </v-row>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import moment from "moment";
import DatePicker from "v-calendar/lib/components/date-picker.umd";

export default {
    name: "general-edit-tab",
    components: { DatePicker },
    data() {
        return {
            isFlat: false,
            startDate: "",
            endDate: ""
        };
    },
    computed: {
        ...mapState(["clients", "export_clients", "stores", "tags"]),
        ...mapState("RuleStore", ["activeRule", "errorMessage", "infoProviders", "entryTypes", "loadingRuleData"])
    },
    async mounted() {
        if (this.activeRule.start_date) {
            this.startDate = await moment(this.activeRule.start_date, "DD.MM.YYYY").toDate();
        }
        if (this.activeRule.end_date) {
            this.endDate = await moment(this.activeRule.end_date, "DD.MM.YYYY").toDate();
        }

        if (this.activeRule.amount) {
            this.isFlat = true;
        }
    },
    watch: {
        startDate: function(value) {
            this.updateField(moment(value).format("DD.MM.YYYY"), "start_date");
        },
        endDate: function(value) {
            this.updateField(moment(value).format("DD.MM.YYYY"), "end_date");
        }
    },
    methods: {
        ...mapMutations("RuleStore", ["updateActiveRuleProperty"]),
        ...mapActions(["getFrequentlyUsedQueries"]),
        updateField(value, field) {
            this.updateActiveRuleProperty({ prop: field, value: value });

            if (field === "percent") {
                this.updateActiveRuleProperty({ prop: "amount", value: null });
            } else if (field === "amount") {
                this.updateActiveRuleProperty({ prop: "percent", value: null });
            }
        },
        getDate(value) {
            if (value) return moment(value).format("DD.MM.YYYY");
            else return null;
        }
    }
};
</script>

<style scoped>
.row-title {
    color: #888;
}
</style>
